import { z } from 'zod';

import { zodExecutionLogSchema } from '../validations';

export const zodExecutionLogWithHistorySchema = zodExecutionLogSchema.extend({
  /** Older versions of the same run (latest excluded), newest first. */
  history: z.array(zodExecutionLogSchema),
});

export type ExecutionLogWithHistory = z.infer<
  typeof zodExecutionLogWithHistorySchema
>;
